/**
 * Helper: General
 * -----------------------------------------------------------------------------
 * General helper utility functions.
 * - Functions which don't fit into any of the other utils files.
 * - Add in alphabetical order.
 *
 */

/**
 * Debounce functions for better performance
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param {Function} callback The function to debounce.
 * @param {Number} wait - The amount of time before debounce call is triggered.
 * @param {Boolean} immediate - Trigger the immediately.
 */
import classes from '~/config/classes'
export function passwordRecoverMessage(component) {
  const hasRecovery = component.querySelector('[js-forgot-password="successCheck"]')

  if (hasRecovery) {
    const recoveryMsg = component.querySelector('[js-forgot-password="success"]')
    const recoveryPrompt = component.querySelector('[js-forgot-password="prompt"]')
    recoveryMsg.classList.remove(classes.hidden)

    if (!recoveryPrompt) {
      return
    }
    recoveryPrompt.classList.add(classes.hidden)
  }
}
